import { validateAcls } from 'src/auth';
import type { SerialNumFmt } from './serial-number.entity';
import type { ValidationResult } from 'types';
import { sequenceTokenConfigErrorMessage } from './tokens/Sequence.token.vue';
import { inputTokenConfigErrorMessage } from './tokens/Input.token.vue';
import { fixedTokenConfigErrorMessage } from './tokens/Fixed.token.vue';

export function validateSerialNumberFmtSelect () {
    return validateAcls([ 'sn_format_select' ]);
}

export function validateSerialNumberFmtEdit () {
    return validateAcls([ 'sn_format_update' ]);
}

/** returns which token names appear more than once, if any */
function unqTokensCheck (snFmt: SerialNumFmt): string[] {
    const tokenNameCountMap: Record<string, number> = {};
    for (const token of snFmt.config.tokens) {
        if (!tokenNameCountMap[token.name]) {
            tokenNameCountMap[token.name] = 0;
        }

        tokenNameCountMap[token.name] += 1;
    }
    return Object.keys(tokenNameCountMap).filter(name => tokenNameCountMap[name] > 1);
}

export function validateSnFmt (snFmt: SerialNumFmt): ValidationResult {
    // TODO: add in validations for increment, start, and end for seq tokens
    if (!snFmt.name) {
        return {
            status: 'error',
            errorMessage: 'Name is required',
        };
    }

    if (!snFmt.config.tokens.length) {
        return {
            status: 'error',
            errorMessage: 'At least one token is required',
        };
    }

    const duplicateTokens = unqTokensCheck(snFmt);
    if (duplicateTokens.length > 0) {
        return {
            status: 'error',
            errorMessage: `Format token names must be unique, but duplicates were found: ${duplicateTokens.join(', ')}`,
        };
    }

   for (const token of snFmt.config.tokens) {
        if (!token.name) {
            return {
                status: 'error',
                errorMessage: 'Token name is required',
            };
        }

        if (token.type === 'seq') {
            const errorMessage = sequenceTokenConfigErrorMessage(token);
            if (errorMessage) {
                return {
                    status: 'error',
                    errorMessage,
                };
            }
        } else if (token.type === 'datetime') {
            // There is nothing to validate since all of the config is controlled by selections
        } else if (token.type === 'input') {
            const errorMessage = inputTokenConfigErrorMessage(token);
            if (errorMessage) {
                return {
                    status: 'error',
                    errorMessage,
                };
            }
        } else if (token.type === 'fixed') {
            const errorMessage = fixedTokenConfigErrorMessage(token);
            if (errorMessage) {
                return {
                    status: 'error',
                    errorMessage,
                };
            }
        } else {
            const unknownToken: never = token;
            return {
                status: 'error',
                errorMessage: `Unknown token type: ${JSON.stringify(unknownToken)}`,
            };
        }
   }

    return {
        status: 'success',
    };
}
